import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'

export function Stats({ world }) {
  const [data, setData] = useState({ fps: 0, cpu: 0, gpu: 0, draws: 0, pos: { x: 0, y: 0 }, ping: 0, netIn: 0, netOut: 0 })

  useEffect(() => {
    world.on('stats', setData)
  }, [])

  return (
    <div
      className='stats'
      css={css`
        position: absolute;
        top: 0;
        left: 0;
        padding: 15px;
        padding-left: calc(15px + env(safe-area-inset-left));
        padding-top: calc(15px + env(safe-area-inset-top));
        .stats-stat {
          display: flex;
          align-items: center;
          font-size: 16px;
          /* font-weight: 600; */
          line-height: 1;
          margin: 0 0 3px;
          &:last-child {
            margin: 0;
          }
        }
        .stats-name {
          flex: 1;
          padding-right: 10px;
        }
        .stats-value {
          text-align: right;
        }
      `}
    >
      <div className='stats-stat'>
        <div className='stats-name'>FPS</div>
        <div className='stats-value'>{data.fps.toFixed()}</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>CPU</div>
        <div className='stats-value'>{data.cpu.toFixed(1)} ms</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>GPU</div>
        <div className='stats-value'>{data.gpu.toFixed(1)} ms</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>Draw</div>
        <div className='stats-value'>{data.draws}</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>Pos</div>
        <div className='stats-value'>
          {data.pos.x}, {data.pos.y}
        </div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>Ping</div>
        <div className='stats-value'>{data.ping.toFixed()} ms</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>In</div>
        <div className='stats-value'>{(data.netIn / 1024).toFixed(1)} KB/s</div>
      </div>
      <div className='stats-stat'>
        <div className='stats-name'>Out</div>
        <div className='stats-value'>{(data.netOut / 1024).toFixed(1)} KB/s</div>
      </div>
    </div>
  )
}
